import React from 'react';
import { Frame, Navigation } from '@shopify/polaris';
import { useNavigate, useLocation } from 'react-router-dom';

interface AppLayoutProps {
  children: React.ReactNode;
}

export const AppLayout: React.FC<AppLayoutProps> = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const navigationMarkup = (
    <Navigation location={location.pathname}>
      <Navigation.Section
        items={[
          {
            label: 'Dashboard',
            url: '/dashboard',
            selected: location.pathname === '/dashboard',
            onClick: () => navigate('/dashboard'),
          },
          {
            label: 'Settings',
            url: '/settings',
            selected: location.pathname === '/settings',
            onClick: () => navigate('/settings'),
          },
          {
            label: 'Translations',
            url: '/translations',
            selected: location.pathname === '/translations',
            onClick: () => navigate('/translations'),
          },
                      {
              label: 'History',
              url: '/history',
              selected: location.pathname === '/history',
              onClick: () => navigate('/history'),
            },
            {
              label: 'Notifications',
              url: '/notifications',
              selected: location.pathname === '/notifications',
              onClick: () => navigate('/notifications'),
            },
          {
            label: 'Resources',
            url: '/resources',
            selected: location.pathname === '/resources',
            onClick: () => navigate('/resources'),
          },
          {
            label: 'Billing',
            url: '/billing',
            selected: location.pathname === '/billing',
            onClick: () => navigate('/billing'),
          },
        ]}
      />
    </Navigation>
  );

  return (
    <Frame navigation={navigationMarkup}>
      {children}
    </Frame>
  );
}; 